// elements/theming/input-token.ts
import "@adornis/ass/style.js";
import "lit/directives/style-map.js";
import "../../chemistry-lit-element.js";
import "../../chemistry-lite-element.js";
var inputToken = (host) => ({
  fontFamily: `${host.fontFamily}, sans-serif`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  // this is intentional for referencing paddings
  paddingTop: host.spacing.sm,
  paddingLeft: host.spacing.sm,
  paddingRight: host.spacing.sm,
  paddingBottom: host.spacing.sm,
  borderBottom: `2px solid ${host.colors.accent}`,
  borderRadius: `${host.sizes.borderRadius} ${host.sizes.borderRadius} 0 0`,
  fontSize: host.baseFontSize + "px"
});
var inputResetStyle = (host) => ({
  ":host": { display: "block", height: "1em" },
  input: {
    // height: '100%',
    outline: "none",
    width: "100%",
    background: "var(--background, transparent)",
    textAlign: "inherit",
    border: "none",
    margin: "0",
    padding: "0",
    color: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
    fontFamily: "inherit",
    "&::placeholder": {
      color: host.colors.tone.placeholder,
      opacity: "1"
    },
    // remove number spinner
    "&[type=number]::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    "&[type=number]": { MozAppearance: "textfield" },
    // remove search decoration andremove webkit browser x on search input fields
    "&[type=search]::-webkit-search-decoration": {
      WebkitAppearance: "none"
    },
    "&[type=search]::-webkit-search-cancel-button": {
      WebkitAppearance: "none"
    },
    "&[type=search]::-webkit-search-results-button": {
      WebkitAppearance: "none"
    },
    "&[type=search]::-webkit-search-results-decoration": {
      WebkitAppearance: "none"
    }
  }
});
export {
  inputResetStyle,
  inputToken
};
